import './App.css';
import init from "./wasm/fluid_simulation.js"
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    init().catch((error) => {
      if (!error.message.startsWith("Using exceptions for control flow, don't mind me. This isn't actually an error!")) {
        throw error;
      }
    });
  }, []);

return (
    <div>
        <canvas id="fluid-simulation-canvas" width="800" height="600"></canvas>
    </div>
)
}

export default App;
